var _circle, _path, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomDomainGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#146EB4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0083 47.4357C40.5297 47.4314 47.4363 40.5223 47.4363 32.0001C47.4363 23.4752 40.5254 16.5645 32.0004 16.5645C23.4753 16.5645 16.5645 23.4752 16.5645 32.0001C16.5645 40.5223 23.471 47.4314 31.9924 47.4357L32.0004 47.4357L32.0083 47.4357ZM29.5537 18.9431C23.7309 20.0274 19.2438 24.9104 18.7613 30.9232H25.2262C25.5151 26.5927 27.0206 22.4418 29.5537 18.9431ZM34.4471 18.9431C36.9801 22.4418 38.4856 26.5927 38.7745 30.9232H45.2394C44.7569 24.9104 40.2698 20.0274 34.4471 18.9431ZM36.6154 30.9232C36.3019 26.6648 34.6904 22.6045 32.0004 19.2908C29.3103 22.6045 27.6989 26.6648 27.3853 30.9232H36.6154ZM27.3853 33.077H36.6154C36.3019 37.3354 34.6904 41.3957 32.0004 44.7094C29.3103 41.3957 27.6988 37.3354 27.3853 33.077ZM25.2262 33.077H18.7613C19.2438 39.0898 23.7309 43.9727 29.5536 45.057C27.0205 41.5583 25.5151 37.4075 25.2262 33.077ZM34.4471 45.057C36.9802 41.5583 38.4856 37.4075 38.7745 33.077H45.2394C44.7569 39.0898 40.2698 43.9727 34.4471 45.057Z",
    fill: "#146EB4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 9,
    fill: "#EE741F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33682_317892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7247 50.7461C59.967 50.7461 60.1634 50.9425 60.1634 51.1848V53.5424C60.1634 53.7847 59.967 53.9812 59.7247 53.9812H57.3671C57.1248 53.9812 56.9284 53.7847 56.9284 53.5424C56.9284 53.3001 57.1248 53.1037 57.3671 53.1037H59.2859V51.1848C59.2859 50.9425 59.4824 50.7461 59.7247 50.7461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9997 51.0494C54.4899 51.0494 53.9851 51.1499 53.5141 51.3452C53.0432 51.5404 52.6153 51.8266 52.2551 52.1874C52.0839 52.3589 51.8061 52.3591 51.6346 52.1878C51.4632 52.0166 51.463 51.7388 51.6342 51.5674C52.0759 51.125 52.6005 50.774 53.178 50.5346C53.7555 50.2951 54.3745 50.1719 54.9997 50.1719C55.6248 50.1719 56.2439 50.2951 56.8214 50.5346C57.3987 50.774 57.9232 51.1248 58.3649 51.567C58.365 51.5671 58.3648 51.5669 58.3649 51.567L60.0345 53.2317C60.2061 53.4028 60.2065 53.6806 60.0354 53.8522C59.8643 54.0238 59.5865 54.0242 59.4149 53.8531L57.7449 52.1881L57.7443 52.1874C57.384 51.8266 56.9562 51.5404 56.4853 51.3452C56.0143 51.1499 55.5095 51.0494 54.9997 51.0494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8359 56.3224C49.8359 56.0801 50.0324 55.8837 50.2747 55.8837H52.6323C52.8746 55.8837 53.071 56.0801 53.071 56.3224C53.071 56.5647 52.8746 56.7612 52.6323 56.7612H50.7134V58.68C50.7134 58.9223 50.517 59.1187 50.2747 59.1187C50.0324 59.1187 49.8359 58.9223 49.8359 58.68V56.3224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.964 56.0126C50.1351 55.841 50.4129 55.8406 50.5845 56.0117L52.2551 57.6774C52.6153 58.0382 53.0432 58.3244 53.5141 58.5197C53.9851 58.7149 54.4899 58.8154 54.9997 58.8154C55.5095 58.8154 56.0143 58.7149 56.4853 58.5197C56.9562 58.3244 57.384 58.0382 57.7443 57.6774C57.9155 57.506 58.1933 57.5058 58.3647 57.677C58.5362 57.8482 58.5364 58.126 58.3652 58.2975C57.9235 58.7398 57.3988 59.0908 56.8214 59.3302C56.2439 59.5697 55.6248 59.6929 54.9997 59.6929C54.3745 59.6929 53.7555 59.5697 53.178 59.3302C52.6007 59.0909 52.0762 58.74 51.6345 58.2978C51.6344 58.2977 51.6346 58.2979 51.6345 58.2978L49.9649 56.6331C49.7933 56.462 49.7929 56.1842 49.964 56.0126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33682_317892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.8,
    fill: "white",
    transform: "translate(49.5996 49.5977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDomainGlobe);
export default __webpack_public_path__ + "static/media/custom-domain-globe.97a45123044d2a8f5359c4546ab36069.svg";
export { ForwardRef as ReactComponent };